import { Component, Inject, Input, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { WindowService } from 'src/app/core/services/window.service';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { DataService } from 'src/app/core/services/data.service';
import { ViewportScroller } from '@angular/common';
declare var window: any;

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss'],
  animations: [
    trigger('flipImage', [
      state('default', style({
        transform: 'rotateY(0deg)',
        opacity: 1,
      })),
      state('flipped', style({
        transform: 'rotateY(180deg)',
        opacity: 0,
      })),
      transition('default <=> flipped', animate('0.5s ease-in-out')),
    ]),
  ],
})
export class HeroComponent implements OnInit {

  @Input() brands: any[] = [];
  @ViewChild('swiper', { static: true }) swiper!: SwiperComponent;

  imageUrls: string[] = [];
  specialImageIndices = [1, 3, 11, 14];

  public grades: any = [];

  config: SwiperOptions = {
    // slidesPerView: 1,
    spaceBetween: 25,
    pagination: true,
    loop: true,
    loopedSlides: 10,
    autoplay: {
      delay: 1000
    }
  }
  animationInProgress = false;



  constructor(@Inject(LOCALE_ID) public locale: string, private windowSrv: WindowService, private data: DataService,private scroller: ViewportScroller) {

  }

  ngOnInit(): void {
    // console.log('Hero', 'init');
    if (this.windowSrv.isBrowser) {
      setInterval(() => {
      // Call the function to shuffle special images every 3 seconds
        this.shuffleSpecialImages();
      }, 4000);
    }

    // Initialize image URLs
    for (let i = 1; i <= 15; i++) {
      this.imageUrls.push(`./assets/images/hero/flips/${i}.jpg`);
    }



    this.grades = this.data.grades;
  }

  scrollToGrades() {
    this.scroller.scrollToAnchor("grades-sec");
  }

  shuffleSpecialImages() {
    // Create a copy of the specialImageIndices array
    const shuffledIndices = [...this.specialImageIndices];

    // Shuffle the copied array
    for (let i = shuffledIndices?.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledIndices[i], shuffledIndices[j]] = [shuffledIndices[j], shuffledIndices[i]];
    }

    // Update the image URLs based on the shuffled indices
    this.specialImageIndices.forEach((index, i) => {
      this.imageUrls[index] = `./assets/images/hero/flips/${shuffledIndices[i] + 1}.jpg`;
    });
  }


  scheduleScroll() {
    setInterval(() => {
      this.swiper.swiperRef.slideNext();
      this.scheduleScroll();
    }, 1000)
  }

  onSwiper(swiper: SwiperComponent) {
    if (this.windowSrv.isBrowser) this.startAnimation();
  }
  onSlideChange() {
  }

  startAnimation() {
    if (this.animationInProgress) return;
    this.animationInProgress = true;
    setTimeout(() => {
      this.swiper.swiperRef.slideNext(1500);
      this.animationInProgress = false;
      this.startAnimation();
    }, 3000);
  }

  next() {
    this.swiper.swiperRef.slideNext(1000);
  }

}
